const typeValues = [
  'REQUESTING',
  'REHYDRATE',
  'SET_DISPLAY_TITLE',
  'SET_INTERVIEW_DATE',
  'SET_INTERVIEW_TIME',
  'SET_INTERVIEW_DURATION',
  'GET_INTERVIEWER_LIST',
  'GET_INTERVIEWER_LIST_ERROR',
  'GET_INTERVIEWER_LIST_SUCCESS',
  'SET_INTERVIEWER',
  'GET_ALL_CODE_MCQ',
  'GET_ALL_CODE_MCQ_SUCCESS',
  'GET_ALL_CODE_MCQ_ERROR',
  'SEARCH_CANDIDATES',
  'SEARCH_CANDIDATES_SUCCESS',
  'SEARCH_CANDIDATES_ERROR',
  'RESET_CANDIDATES_SEARCH_LIST',
  'ADD_CANDIDATE_TO_LCI',
  'GET_LCI_CANDIDATE_INFO',
  'GET_LCI_CANDIDATE_INFO_SUCCESS',
  'GET_LCI_CANDIDATE_INFO_ERROR',
  'CREATE_LCI',
  'CREATE_LCI_SUCCESS',
  'CREATE_LCI_ERROR',
  'SEND_LCI_ACCESS_CODE',
  'SEND_LCI_ACCESS_CODE_SUCCESS',
  'SEND_LCI_ACCESS_CODE_ERROR',
  'UPDATE_LCI',
  'UPDATE_LCI_SUCCESS',
  'UPDATE_LCI_ERROR',
  'EDIT_LCI',
  'GET_ALL_CANDIDATES_FOR_EDIT_LCI',
  'GET_ALL_CANDIDATES_FOR_EDIT_LCI_SUCCESS',
  'GET_ALL_CANDIDATES_FOR_EDIT_LCI_ERROR',
  'RESET_DATA',
  'CLEAR_SUCCESS_ERROR_FLAGS',
  'GET_LCI_LISTING',
  'GET_LCI_LISTING_SUCCESS',
  'GET_LCI_LISTING_ERROR',
  'START_LCI',
  'START_LCI_SUCCESS',
  'START_LCI_ERROR',
  'SET_CODE_CHALLENGE',
  'CHECK_LCI_CODE_INTERVIEWER',
  'CHECK_LCI_CODE_INTERVIEWER_SUCCESS',
  'CHECK_LCI_CODE_INTERVIEWER_ERROR',
  'SET_JOIN_LCI_INFO',
  'CANDIDATE_JOIN_INTERVIEW',
  'RESET_CANDIDATES_LIST',
  'REPLAY_DATA',
  'GET_ALL_CANDIDATES_FOR_LCI',
  'GET_ALL_CANDIDATES_FOR_LCI_SUCCESS',
  'GET_ALL_CANDIDATES_FOR_LCI_ERROR',
  'END_LCI',
  'END_LCI_SUCCESS',
  'END_LCI_ERROR',
  'CANCEL_LCI',
  'CANCEL_LCI_SUCCESS',
  'CANCEL_LCI_ERROR',
  'SET_EMAIL_CHECK',
  'RESET_ACCESS_CODE_SEND_MESSAGE',
  'INTERVIEWER_JOIN_INTERVIEW',
  'MESSAGE',
  'CLEAR_LATEST_MESSAGE',
  'SAVE_NOTE',
  'SUBMIT_NOTE',
  'SUBMIT_NOTE_SUCCESS',
  'SUBMIT_NOTE_ERROR',
  'GET_LATEST_SUBMIT_INFO',
  'GET_LATEST_SUBMIT_INFO_SUCCESS',
  'GET_LATEST_SUBMIT_INFO_ERROR',
  'SEND_AUDIO_SWITCH',
  'LOCAL_AUDIO_SWITCH',
  'LOCAL_VIDEO_SWITCH',
  'REPLAYER_DIMENSION',
  'REPLAYER_MAX_MIN',
  'SWITCH_VOICE_BROADCAST',
  'VIDEO_READY',
  'MASTER_LIVE_ALERT',
  'MASTER_VIDEO_ALERT',
  'CANDIDATE_ACTIVITY_ALERT',
  'CANDIDATE_DISCONNECT',
  'CLEAR_START_LCI_FLAG',
  'RESET_DATA_LCI_MONITORING',
  'END_LCI_FOR_USER',
  'END_LCI_FOR_USER_SUCCESS',
  'END_LCI_FOR_USER_ERROR'
];

const types = typeValues.reduce((acc, curr) => { acc[curr] = curr; return { ...acc }; }, {});

export default types;
